import { render, staticRenderFns } from "./DeletedSystems.vue?vue&type=template&id=2a51fdef"
import script from "./DeletedSystems.vue?vue&type=script&lang=js"
export * from "./DeletedSystems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a51fdef')) {
      api.createRecord('2a51fdef', component.options)
    } else {
      api.reload('2a51fdef', component.options)
    }
    module.hot.accept("./DeletedSystems.vue?vue&type=template&id=2a51fdef", function () {
      api.rerender('2a51fdef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Systems/DeletedSystems.vue"
export default component.exports